import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function DesignBuildElevate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4054" id="californias-premier-deck-builders" className="relative h-screen w-full overflow-hidden flex flex-col items-center justify-center text-center dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/40 z-10" />
        <div className="h-full w-full bg-cover bg-center bg-no-repeat bg-[url(/img/mahogany-deck-sunset-sf.jpg)] transform scale-105 motion-safe:animate-[subtle-zoom_20s_infinite_alternate]" aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-20 container mx-auto px-4 flex flex-col items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h1 className="font-default text-6xl md:text-8xl lg:text-9xl text-white tracking-tight drop-shadow-lg leading-tight font-bold">
          California’s Premier Deck Builders
        </h1>
        
        <p className="mt-6 md:mt-8 text-lg md:text-2xl text-white/90 font-default max-w-3xl font-light tracking-wide">
          Crafting Luxury Outdoor Living Since 1990.
        </p>

        <div className="mt-10 md:mt-12">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-none text-lg px-8 py-6 h-auto rounded-sm transition-all duration-300 hover:shadow-[0_0_25px_var(--color-primary)] hover:scale-105">
            <Link to="#">
              Request Free Site Visit
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 z-20 pb-8 flex flex-col items-center gap-2 opacity-80">
        <span className="text-xs uppercase tracking-[0.2em] text-white/70 font-default mb-2">Scroll</span>
        <div className="h-16 w-[1px] bg-primary animate-pulse shadow-[0_0_10px_var(--color-primary)]" />
      </div>

      {}
      <style jsx global>{`
        @keyframes subtle-zoom {
          0% { transform: scale(1.05); }
          100% { transform: scale(1.15); }
        }
      `}</style>
    </section>;
}